<div>
  <div class="box">
    <div class="drag-handle" cdkDragHandle>
      <button (click)="onClickListaCapas()" class="circle-button">
        <div class="button-icon">
          <img *ngIf="this.layerCatalogService.isExternalLayersVisible" [src]="'icon_capas_externas.svg' | findUrl" class="img-button">
          <img *ngIf="!this.layerCatalogService.isExternalLayersVisible" [src]="'icon_capas_externas_gris.svg' | findUrl" class="img-button">
        </div>
      </button>
    </div>
    <div [@mostrarLista]="this.layerCatalogService.isExternalLayersVisible ? 'visible' : 'hidden'" class="switch-list" [ngClass]="{'overflowHidden': this.panelExternalLayerService.isExpandCollapseAnimating}">
      <div>
        <div class="tool-title">
          <mat-icon (click)="toggleExternalLayers()" class="expand-icon" [ngClass]="{'expanded': this.panelExternalLayerService.isExternalLayersExpanded}">expand_more</mat-icon>
          <h2>Capas Externas</h2>
          <!-- <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false"  fontIcon="cancel" (click)="ClosePanel()"></mat-icon> -->
        </div>
        <div [@expandCollapseLayers]="this.panelExternalLayerService.isExternalLayersExpanded ? 'expanded' : 'collapsed'" (@expandCollapseLayers.start)="onExpandCollapseStart($event)" (@expandCollapseLayers.done)="onExpandCollapseDone($event)" class="switch-container" [cdkDropListData]="$capas" cdkDropList (cdkDropListDropped)="onDropLayer($event)">
          <div *ngFor="let capa of $capas" class="switch-item" cdkDrag>
            <div class="switch-searcher col-1">
              <mat-icon *ngIf="capa.checked" class="refresh-icon" (click)="onRestartLayer(capa)" matTooltip="Recargar capa">refresh</mat-icon>
            </div>
            <label class="switch col-3">
              <!-- <img *ngIf="capa.checked" [src]="'btn_add_green.svg' | findUrl" class="img-button" [id]="capa.name" (click)="onToggleLayer(capa.name)"> -->
              <img *ngIf="!capa.checked" [src]="'btn_add_grey.svg' | findUrl" class="img-button" [id]="capa.name" (click)="onToggleLayer(capa.name)">
            </label>
            <span class="col-5 layer-name">
              <!-- <img [src]="capa.icon | findUrl" class="img-layer"> -->
              {{ capa.name }}
            </span>
            <div class="switch-loading col-2">
              <loading [isLoading]="capa.isLoading" [isAbsolute]="false"></loading>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>